import type { DragObject } from '@mimir/web/pages/search/components/search-page-interfaces';
import { reactive } from 'vue';

export interface GlobalDragState {
  dragObject: DragObject | null,
  ctrlOrAlt: boolean,
}

export let globalDragState = reactive<GlobalDragState>({
  dragObject: null,
  ctrlOrAlt: false,
});
